import React from "react";
import "./Signature.css";

export default function Signature() {
    return (
        <p className="signature">
            <a href="https://github.com/VildeMargrethe/react-weather-app" target="_blank" rel="noopener noreferrer">
                Open source code {" "}
            </a>
            by Vilde Margrethe Sætre Strand
        </p>
    );
}